import {Component, OnInit, ViewChild} from '@angular/core';
import {SyncService} from "./sync.service";
import {Device} from "../../model/device.model";
import {MatTableDataSource} from "@angular/material/table";
import {MatPaginator} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import {MY_FORMATS, UtilService} from "../../shared/util.service";
import moment from 'moment';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from "@angular/material/core";
import {MomentDateAdapter} from "@angular/material-moment-adapter";

@Component({
    selector: 'app-ax-mpoint-sync',
    templateUrl: './ax-mpoint-sync.component.html',
    styleUrls: ['./ax-mpoint-sync.component.scss'],
    providers: [
        { provide: MAT_DATE_LOCALE, useValue: 'hu-HU' },
        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    ],
    standalone: false
})
export class AxMpointSyncComponent implements OnInit {

  dates = {
    start: moment().subtract('1', 'months').startOf('month'),
    end: moment()
  }

  devices: Device[] = [];
  dataSource = new MatTableDataSource(this.devices);
  searchText = null;
  displayedColumns: string[] = [
    'nodeid',
    'target',
    'name',
    'site',
    'sync',
    'actions'
  ];

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  constructor(
    private service: SyncService,
    private util: UtilService,
  ) { }

  ngOnInit(): void {
    this.fetchItems();
    this.setDatatable();
  }

  fetchItems() {
    this.service.get15minDevices().subscribe((resp: any) => {
      if (resp.data) {
        this.devices = resp.data.map(d => new Device(d))
        this.dataSource.data = this.devices;
      }
    })
  }

  setDatatable() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.dataSource.sortingDataAccessor = this.util.tableSorting;
  }

  applyFilter() {
    this.dataSource.filter = this.searchText.trim().toLowerCase();
  }

  onSyncClick(item) {
    const param = {
      value: item.getSync15MinAttr(),
      node: item.nodeID,
      start: this.dates.start.format('YYYY-MM-DD 00:00:00'),
      end: this.dates.end.add(1,'day').format('YYYY-MM-DD 00:00:00')
    }
    this.service.triggerSync(item.id, param).subscribe((resp: any) => {
      if (resp.error) {
        return this.service.notiService.open(resp.error);
      }
      let saveCount = 0;
      if (resp.success && resp.saved) {
        saveCount = resp.saved;
      }
      this.service.notiService.open(`Sync called. ${saveCount ? saveCount + ' data saved' : ''}`)
    })
  }

}
